import Link from 'components/link/Link';

import { ITopFilter } from 'source/NFR.types';

const TopFilter: React.FC<ITopFilter> = ({ options = [], title, timeframe }) => (
  <div className="top-filter">
    <p>{title}</p>
    <input type="hidden" id={timeframe.id} name={timeframe.name} value={timeframe.value} />
    {options?.map(option => {
      return (
        <div className="top-filter--input" key={option.link.url}>
          <Link theme={option.isCurrent ? 'black' : undefined} {...option.link} />
        </div>
      );
    })}
  </div>
);

TopFilter.displayName = 'TopFilter';

export default TopFilter;
